import { loginSchema } from "./schemas";

const VALIDATIONS = {
  loginSchema,
};

export default VALIDATIONS;
